/* eslint-disable */

import debounce from 'lodash/debounce';
import differenceBy from 'lodash/differenceBy';
import isEmpty from 'lodash/isEmpty';

// Constants
import { isMobile } from 'constants';


function initAudioKey() {
  if (!sessionStorage.tabAudioKey) {
    // console.log("No TAK, initializing");
    sessionStorage.setItem("tabAudioKey", Math.floor(Math.random() * 1000000000));
  } else {
    // console.log("TAK exists");
  }

  if (!localStorage.portalAudioKey || !localStorage.portalAudioKeyKeepalive) {
    // console.log("No PAK or keepalive, initializing");
    localStorage.setItem("portalAudioKey", sessionStorage.tabAudioKey);
    localStorage.setItem("portalAudioKeyKeepalive", (new Date()).getTime());
  } else {
    console.log("PAK exists and...");
    if (sessionStorage.tabAudioKey === localStorage.portalAudioKey) {
      // console.log("PAK is this tab, updating keepalive");
      localStorage.setItem("portalAudioKeyKeepalive", (new Date()).getTime());
    }
    else if (localStorage.portalAudioKeyKeepalive && parseInt(localStorage.portalAudioKeyKeepalive) < parseInt((new Date()).getTime() - 15000)) {
      // console.log("PAK not this tab, but keepalive over 15 seconds old, re-initializing")
      localStorage.setItem("portalAudioKey", sessionStorage.tabAudioKey);
      localStorage.setItem("portalAudioKeyKeepalive", (new Date()).getTime());      
    } else {
      // console.log("PAK not this tab, has recent keepalive");
    }
  }
}

initAudioKey();
setInterval(() => {
  initAudioKey();
}, 5000)

const soundAlarm = () => {
  // console.log(`----------debounced alarm called--------\n`);
  document.getElementById('triage-audio').play()
    .then(() => {
      // console.log(`----------alarm promise resolved--------\n`);
    })
    .catch(error => {
      // console.log(`----------alarm promise rejected with error--------\n`, error);
      // console.log(`----------alarm promise rejected with code--------\n`, error.code);
      // console.log(`----------alarm promise rejected with message--------\n`, error.message);
      // console.log(`----------alarm promise rejected with name--------\n`, error.name);
    });
};
const debounceAlarm = debounce(soundAlarm, 1000, { leading: true, trailing: false });

export default function newTriageAlert(oldItems = [], currentItems = []) {
  
  // console.log("Starting newTriageAlert")

  // Don't alarm if portal audio key is set and it's not us
  if (localStorage.portalAudioKey !== sessionStorage.tabAudioKey) {
    // console.log("TAK!=PAK, not playing triage sound")
    // console.log("tabAudioKey", sessionStorage.tabAudioKey)
    // console.log("portalAudioKey", localStorage.portalAudioKey)
    // console.log("JUST KIDDING, playing sound for now")
    // Still play for now while in development... live :)
    // return;
  }

  // Never alarm on mobile
  if (isMobile) {
    // console.log("isMobile, not playing triage sound");
    return;
  }

  // Don't play the sound on page load
  if (!oldItems.length) {
    // console.log("First page load, not playing triage sound");
    return;    
  };

  const newItems = differenceBy(currentItems, oldItems, 'id');
  const needsAlarm = newItems.filter(item => {
    const active = item.status === 'Active';
    const claimed = !isEmpty(item.claimed);
    const ok = item.monitoringAlertStatus === 'Ok';
    return active && !claimed && !ok;
  });

  if (needsAlarm.length) {
    // console.log(`----------alarm called pre-debounce--------\n`);
    debounceAlarm();
  } else {
    console.log("needsAlarm count zero", newItems, needsAlarm)
  }
}

